import React, { useState } from 'react';
import axiosInstance from '../../interceptor/axiosInstance';
import { toast } from '../Library/SubMenus/MCQAssessment/toastUtils';
import FaclityExtraFrom from "./UserExtraPopUp/FaclityExtraFrom";
import StudentExtraForm from './UserExtraPopUp/StudentExtraForm';

const AddSingleUser = () => {
  const initialFormState = {
    email: '',
    first_name: '',
    last_name: '',
    mobile_number: '',
    username: '',
    type: 'student',
  };

  const [formData, setFormData] = useState(initialFormState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [mobileError, setMobileError] = useState('');
  const [userResponse, setUserResponse] = useState(null); 
  const [showPopup, setShowPopup] = useState(false); 

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'mobile_number') {
      setMobileError('');
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(formData.mobile_number)) {
      setMobileError('Mobile number must be exactly 10 digits.');
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await axiosInstance.post('accounts/users/', formData);
      const userData = response.data?.data;
      setUserResponse(userData);

      toast.success('User Added', 'User has been added successfully!');
      setShowPopup(true); // Open popup after toast

      setFormData(initialFormState);
    } catch (err) {
      const backendData = err.response?.data || {};
      const message = backendData.message || 'Failed to add user. Please try again.';
  
      let errorText = message;
  
      if (backendData.errors) {
        for (const [field, messages] of Object.entries(backendData.errors)) {
          if (Array.isArray(messages)) {
            errorText += `\n${field}: ${messages.join(', ')}`;
          }
        }
      }

      toast.error('Failed to Add User', errorText);
    } finally {
      setIsSubmitting(false);
    }
  };

  const isStudentType = (type) => type === 'student';

  return (
    <div className="add-single-user-modal">
      <div className="add-single-user-header">
        <h2>Add Single User</h2>
        <p className="add-single-user-subtitle">Fill in the details to add a new user to the system</p>
      </div>
      <form onSubmit={handleSubmit} className="add-single-user-form">
        <div className="add-single-user-row">
          <div className="add-single-user-field">
            <label>First Name:</label>
            <input
              type="text"
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              required
              placeholder="Enter first name"
            />
          </div>

          <div className="add-single-user-field">
            <label>Last Name:</label>
            <input
              type="text"
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Enter last name"
            />
          </div>
        </div>

        <div className="add-single-user-row">
          <div className="add-single-user-field">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="user@example.com"
            />
          </div>

          <div className="add-single-user-field">
            <label>Mobile Number:</label>
            <input
              type="tel"
              name="mobile_number"
              value={formData.mobile_number}
              onChange={handleChange}
              required
              placeholder="10-digit mobile number"
              maxLength="10"
            />
            {mobileError && <p className="add-single-user-error">{mobileError}</p>}
          </div>
        </div>

        <div className="add-single-user-row">
          <div className="add-single-user-field">
            <label>Registration ID/ Employee ID:</label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Enter unique ID"
            />
          </div>
          <div className="add-single-user-field">
            <label>User Type:</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              required
            >
              <option value="student">Student</option>
              <option value="faculty">Faculty</option>
              <option value="prospective_faculty">Prospective Faculty</option>
            </select>
          </div>
        </div>

        <div className="add-single-user-actions">
          <button type="submit" className="add-single-user-submit" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <span className="add-single-user-spinner"></span>
                Submitting...
              </>
            ) : (
              'Add User'
            )}
          </button>
        </div>
      </form>

      {showPopup && userResponse?.id && (
        <div className="add-single-user-secondary-popup">
          <div className="add-single-user-secondary-content">
            {isStudentType(userResponse.user_type) ? (
              <StudentExtraForm id={userResponse.id} onClose={() => setShowPopup(false)} />
            ) : (
              <FaclityExtraFrom id={userResponse.id} onClose={() => setShowPopup(false)} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AddSingleUser;
